import React, {FC, PropsWithChildren, ReactNode} from "react";
import "./ui.css";

type PanelProps = PropsWithChildren<{
    title?: ReactNode;
    description?: ReactNode;
    extra?: ReactNode;
    // Flat panels sit inside another surface (drawer, modal) and drop the shadow.
    flat?: boolean;
    className?: string;
    headingLevel?: 2 | 3;
    "aria-label"?: string;
}>;

export const Panel: FC<PanelProps> = ({title, description, extra, flat, className, headingLevel = 3, children, ...rest}) => {
    const Heading = headingLevel === 2 ? "h2" : "h3";

    return (
        <section
            className={["ati-panel", flat ? "ati-panel--flat" : "", className].filter(Boolean).join(" ")}
            aria-label={rest["aria-label"]}
        >
            {title || description || extra ? (
                <div className="ati-panel__head">
                    <div className="ati-panel__heading">
                        {title ? <Heading className="ati-panel__title">{title}</Heading> : null}
                        {description ? <p className="ati-panel__description">{description}</p> : null}
                    </div>
                    {extra ? <div className="ati-panel__extra">{extra}</div> : null}
                </div>
            ) : null}
            <div className="ati-panel__body">{children}</div>
        </section>
    );
};
